export const version = "bignumber/5.5.0";
